module.exports = __webpack_public_path__ + "static/media/46_B.7453ae31.png";